"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var web_base_1 = require("@tencent/web-base");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var init_aegis_1 = tslib_1.__importDefault(require("../../_util/init-aegis"));
var use_config_1 = require("../../_util/config-context/use-config");
var DownloadInfo = function (props) {
    var classPrefix = (0, use_config_1.useConfig)().classPrefix;
    var _a = tslib_1.__read((0, react_1.useState)(''), 2), version = _a[0], setVersion = _a[1]; // 版本号
    var permissions = 'https://privacy.qq.com/document/preview/086e36a8493545cc9c6032dd4ab0159e';
    var privacy = 'https://privacy.qq.com/document/preview/4467add90f9d4baaabd790cb1cb08b26';
    (0, react_1.useEffect)(function () {
        getVersion();
    }, []);
    /**
     * 获取版本号
     */
    var getVersion = function () {
        var downloadConfig = [];
        if ((0, web_base_1.isAndroid)()) {
            downloadConfig.push({
                'package-type': 'app',
                channel: '0300000000',
                platform: 'android',
            });
        }
        else {
            downloadConfig.push({
                'package-type': 'app',
                channel: '1410000001',
                platform: 'ios',
            });
        }
        var fixData = encodeURIComponent(JSON.stringify(downloadConfig));
        var nonce = (0, web_base_1.randomString)(16);
        props.http.get('', "/web-service/query-download-info?q=".concat(fixData), { nonce: nonce }).then(function (res) {
            var e_1, _a;
            var code = res.code;
            var list = res['info-list'];
            if (code === 0 && list instanceof Array) {
                try {
                    for (var list_1 = tslib_1.__values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                        var item = list_1_1.value;
                        if (item === null || item === void 0 ? void 0 : item.version) {
                            setVersion(item.version);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        })
            .catch(function (err) {
            init_aegis_1.default === null || init_aegis_1.default === void 0 ? void 0 : init_aegis_1.default.logAll('queryAppVersion-->', err);
            console.error('queryAppVersion-->', err);
        });
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-download-factor"), props.className) },
        react_1.default.createElement("p", null, "\u5F00\u53D1\u8005\uFF1A\u6DF1\u5733\u5E02\u817E\u8BAF\u8BA1\u7B97\u673A\u7CFB\u7EDF\u6709\u9650\u516C\u53F8"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("span", null,
                "\u7248\u672C\u53F7\uFF1A",
                version),
            react_1.default.createElement("a", { href: permissions }, "\u5E94\u7528\u6743\u9650"),
            react_1.default.createElement("a", { href: privacy }, "\u9690\u79C1\u653F\u7B56"))));
};
exports.default = DownloadInfo;
//# sourceMappingURL=download-Info.js.map